import { createFileRoute, ClientOnly } from "@tanstack/react-router";
import { lazy, Suspense } from "react";

const SanityStudio = lazy(() => import("@/pages/SanityStudio"));

export const Route = createFileRoute("/admin/$")({
  ssr: false,
  head: () => ({
    meta: [
      { title: "Studio | JTB Floors" },
      { name: "robots", content: "noindex,nofollow" },
    ],
  }),
  component: AdminRoute,
});

function AdminRoute() {
  return (
    <ClientOnly
      fallback={
        <div style={{ height: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
          Loading Studio…
        </div>
      }
    >
      <Suspense
        fallback={
          <div style={{ height: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
            Loading Studio…
          </div>
        }
      >
        <SanityStudio />
      </Suspense>
    </ClientOnly>
  );
}
